export default __webpack_public_path__ + "f3c7314c855fbe63e4a9d40b0326ab13.png";